<p *ngIf="saveState.saving">Salvataggio in corso...</p>
<p *ngIf="!saveState.saving && saveState.lastSaved">Salvato {{ saveState.lastSaved | amLocale:'it' | amTimeAgo }}</p>
